// Signed-out area (/welcome, /login, /sign-up, /forgot-password; FR-002, FR-013, FR-034; routes.md).
// A signed-in user goes to the destination chosen at sign-in (pending join, returnTo or role
// landing, postSignIn.ts), else to their landing.
import { type Href, Redirect, Slot } from "expo-router";

import { landingHref, resolveLanding } from "@/session/access";
import { useSession, useSessionController } from "@/session/hooks";
import { usePlatform } from "@/session/platform";
import { RouteGuard } from "@/shell/RouteGuard";

export default function SignedOutLayout() {
  const session = useSession();
  const platform = usePlatform();
  const { peekPostSignInHref } = useSessionController();
  if (session.status === "signedIn") {
    const landing = resolveLanding(session, platform);
    // An unsupported landing (school admin on Android) is shown by the parent area (FR-028).
    const href = peekPostSignInHref() ?? landingHref(landing) ?? "/";
    return <Redirect href={href as Href} />;
  }
  return (
    <RouteGuard area="signedOut">
      <Slot />
    </RouteGuard>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
